import { files } from 'dropbox';
import { StorageGetNextListPage, StorageListPage } from '../common/list-page';
import { DropboxFile, DropboxItem } from './dropbox.item';

export class DropboxListPage implements StorageListPage {
  constructor(
    private readonly storage: StorageGetNextListPage,
    private readonly result: files.ListFolderResult,
    private readonly onlyFolders: boolean,
  ) {}

  public getItems(): DropboxItem[] {
    return (this.result.entries ?? [])
      .filter((file): file is DropboxFile => file['.tag'] !== 'deleted')
      .filter((file) => (this.onlyFolders ? file['.tag'] === 'folder' : true))
      .map((file) => new DropboxItem(file));
  }

  public hasNext(): boolean {
    return this.result.has_more;
  }

  public async getNext(): Promise<StorageListPage> {
    if (!this.hasNext()) {
      throw new Error('Next page requested for the last page.');
    }

    return this.storage.getNextFolderPage(this.onlyFolders, {
      cursor: this.result.cursor,
    });
  }
}
